import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import actions from './actions';
import viewBookingActions from '../actions';
import loadBookingActions from '../../../actions';
import Api from '../../../../../../helpers/api';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import { t } from '../../../../../../i18n';

const clockInClockOutApi = new Api('bookings/:id/clock_in_out');

function getIndexedArray(array, startIndex) {
  return array.map((item, index) => ({ ...item, index: startIndex + index }));
}

function* loadClockInClockOutRequest(data) {
  try {
    const {
      page = 1,
      pageSize = 20,
      column,
      order,
      filter = '',
      id,
      bookingStartedAt,
      bookingFinishedAt,
    } = data.payload;
    const result = yield call(
      sendRequest,
      clockInClockOutApi.load,
      { search: { page, pageSize, column, order, filter }, id },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      const { data: response } = result.data.success;
      const { totalCount, filteredCount, sortableColumns } = response;
      const indexedData = getIndexedArray(response.records, (page - 1) * pageSize);
      const dataResult = {
        data: indexedData,
        totalCount,
        filteredCount,
        sortableColumns,
        bookingStartedAt,
        bookingFinishedAt,
      };
      yield put(actions.loadClockInClockOutSuccess(dataResult));

      return { data: dataResult };
    }

    yield put(viewBookingActions.closeBulkEditCheckinCheckoutModal());

    return result;
  } catch (error) {
    logger.error(error);
  }
}

function* updateClockInClockOutRequest(data) {
  const { booking, isModalsShouldBeClosed = true } = data.payload;
  const bulkEditCheckinCheckoutState = yield select(state => state.BulkEditCheckinCheckout);
  const { editForm } = bulkEditCheckinCheckoutState;
  const shifts = [];
  let hasErrors = false;

  Object.keys(editForm).forEach(key => {
    if (!hasErrors) {
      hasErrors = Object.keys(editForm[key]).some(rowKey => {
        return editForm[key][rowKey].error && editForm[key][rowKey].error !== '';
      });
    }
  });

  try {
    if (!hasErrors) {
      if (editForm && Object.keys(editForm).length) {
        Object.keys(editForm).forEach(key => {
          const { id: shiftId, started_at, finished_at } = editForm[key];

          // if (started_at.touched || finished_at.touched) {
          shifts.push({
            id: shiftId.value,
            started_at: started_at.value,
            finished_at: finished_at.value,
          });
          // }
        });
      }

      const result = yield call(
        sendRequest,
        clockInClockOutApi.updateItem,
        { data: { shifts }, id: booking.id },
        notifications.REQUEST_ERROR,
      );

      if (result) {
        if (result.data) {
          yield put(actions.updateClockInClockOutSuccess());

          if (isModalsShouldBeClosed) {
            yield put(viewBookingActions.closeBulkEditCheckinCheckoutModal());
          }
          yield put(
            loadBookingActions.loadShifts({
              id: booking.id,
              page: booking.shifts?.page || 1,
            }),
          );
          yield put(
            notifications.addNotification({
              headline: t('dash.common.notification.success_headline'),
              type: 'success',
              message: t('dash.jobs.bookings.bulk_check-in_out_title'),
            }),
          );
        }
      }
    } else {
      yield put(actions.loadClockInClockOutCancel());
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.check_validation_errors'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_CLOCKIN_CLOCKOUT_REQUEST, loadClockInClockOutRequest)]);
  yield all([takeEvery(actions.UPDATE_CLOCKIN_CLOCKOUT_REQUEST, updateClockInClockOutRequest)]);
}
